export class Packages {
    static recruitingAndsales25 = {
        "applicantMaxCount": 25,
        "callsMaxCount": 75,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 250,
        "jobOfferMaxCount": 100,
        "languagesMaxCount": 2,
        "planName": "recruitingAndsales25",
        "poolContigent": 25,
        "smsMaxCount": 75,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }

    static recruitingAndsales50 = {
        "applicantMaxCount": 50,
        "callsMaxCount": 150,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 500,
        "jobOfferMaxCount": 100,
        "languagesMaxCount": 2,
        "planName": "recruitingAndsales50",
        "poolContigent": 50,
        "smsMaxCount": 150,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }

    static recruitingAndsales100 = {
        "applicantMaxCount": 100,
        "callsMaxCount": 300,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 1000,
        "jobOfferMaxCount": 100,
        "languagesMaxCount": 2,
        "planName": "recruitingAndsales100",
        "poolContigent": 100,
        "smsMaxCount": 300,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }

    static apiFree = {
        "applicantMaxCount": 10,
        "callsMaxCount": 30,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 100,
        "jobOfferMaxCount": 100,
        "languagesMaxCount": 2,
        "planName": "api-free",
        "poolContigent": 10,
        "smsMaxCount": 30,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }

    static apiStarter = {
        "applicantMaxCount": 2500,
        "callsMaxCount": 2500,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 2500,
        "jobOfferMaxCount": 500,
        "languagesMaxCount": 3,
        "planName": "api-starter",
        "poolContigent": 0,
        "smsMaxCount": 2500,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }

    static apiProfessional = {
        "applicantMaxCount": 5000,
        "callsMaxCount": 5000,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 5000,
        "jobOfferMaxCount": 1000,
        "languagesMaxCount": 5,
        "planName": "api-professional",
        "poolContigent": 0,
        "smsMaxCount": 5000,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }

    static apiPro = {
        "applicantMaxCount": 10000,
        "callsMaxCount": 10000,
        "contractStart": new Date().toDateString(),
        "eMailMaxCount": 10000,
        "jobOfferMaxCount": 2000,
        "languagesMaxCount": 8,
        "planName": "api-pro",
        "poolContigent": 0,
        "smsMaxCount": 10000,
        "startDateForContigent": new Date().toString(),
        "startingContigent": 0,
        "workFlowMaxCount": 12
    }
}